/**
 * 优惠券展示标识
 */
export const COUPONS_FLAG = {
  /**
   *  展示普通优惠券
   */
  RIGHT1: 'RIGHT1',
  /**
   *  展示普通优惠券
   */
  RIGHT2: 'RIGHT2',
  /**
   * RIGHT3: 展示迁移、普通优惠券
   */
  RIGHT3: 'RIGHT3',
  /**
   * DISCOUNT：展示立减券
   */
  DISCOUNT: 'DISCOUNT',
}

/**
 * 立减券展示标识
 */
export const VOUCHER_DISPLAY_FLAG = {
  /**
   * 无展示
   */
  NONE: 0,
  /**
   * 展示出行券
   */
  TRAVEL: 1,
  /**
   * 展示外卖券
   */
  TAKEAWAY: 2,
  /**
   * 全展示
   */
  ALL: 3,
}

/**
 * 立减券展示标识
 */
export const COUPON_TYPE = {
  /**
   * 出行券
   */
  TRAVEL: '1',
  /**
   * 钱包券
   */
  WALLET: '2',
  /**
   * 外卖券
   */
  TAKEAWAY: '3',
}

/**
 * 权益类型
 */
export const EQUITY_TYPE = {
  /**
   * 立减/开卡礼
   */
  DISCOUNT: 'discountRight',
  /**
   * 返现
   */
  CASHBACK: 'cashback',
  /**
   * 促销商户
   */
  PROMOTIONMERCHANTS: 'promotionMerchants',
  /**
   * MSI
   */
  MSI: 'msi',
  /**
   * 万事达
   */
  MASTERCARD: 'mastercard',
}

export const DISCOUNT_TYPE = {
  // 0 -> 00000000 无权益
  // 1 -> 00000001 出行
  // 2 -> 00000010 外卖
  // 3 -> 00000011 出行 + 外卖
  /**
   * 无权益
   */
  NO: 0,
  /**
   * 出行
   */
  TRAVEL: 1,
  /**
   * 外卖
   */
  FOOD: 2,
  /**
   * 出行 + 外卖
   */
  ALL: 3,
}
/**
 * 优惠卷日期类型
 */
export const COUPON_DATE_TYPE = {
  /**
   * n前有效
   */
  BEFORE: '0',
  /**
   * 领取当天有效
   */
  TODAY: '1',
  /**
   * 领取当月内有效
   */
  MONTH: '2',
  /**
   * 领取当周内有效
   */
  WEEK: '3',
}

/**
 * 优惠卷活动类型
 */
export const ACTIVITY_COUPON_STATUS = {
  /**
   * 正常
   */
  NORMAL: '0',
  /**
   * 未生效
   */
  NOT_EFFECTIVE: '1',
  /**
   * 已过期
   */
  EXPIRED: '2',
  /**
   * 不存在
   */
  ABSENT: '3',
}

/**
 * 用卡权益页banner-优惠活动类型
 */
export const ACTIVITY_COUPON_TYPE = {
  /**
   * 立减
   */
  DISCOUNT: 'DISCOUNT',
  /**
   * 出行
   */
  DISCOUNT_TRAVEL: 'DISCOUNT_TRAVEL',
  /**
   * 外卖
   */
  DISCOUNT_TAKEWAY: 'DISCOUNT_TAKEWAY',

  /**
   * 分期优惠券
   */
  INSTALLMENT_COUPON: 'INSTALLMENT_COUPON',
  /**
   * 营销资源
   */
  MARKETING_RESOURCE: 'MARKETING_RESOURCE',
}

// 展示权益信息的首页
// 101-端外一阶段等待首页 102-端外一阶段通过首页
export const HOME_BENEFITS_PAGE_LIST = [101, 102]



/**
 * 进度条文案分组测试 实验
 */
export const BAR_COPYWRITING = {
  // A：组别1
  A: "A",
  // B：组别2
  B: "B",
  // C：组别2
  C: "C",
  // D：组别4
  D: "D",
};
/**
 * 额度预计最高
 */
export const MAX_MONEY_DETAILS = {
  maxMoney: 35000,
  maxMoneyStr: "35,000",
};
/**
 * 进度条测试 进度
 */
export const PROGRESS_BAR_NUMBER = {
  // 一阶段个人信息1 & curp
  PERINFO1_CURP: [0, 90, 95], // 0用来占位
  // 一阶段征信授权
  CREDIT_AUTHORIZE: [0, 99], // 0用来占位
};
